export default __webpack_public_path__ + "static/SR India - ISO 45001 - Certificate-ee122edfc5c1348094641089525a5e15.pdf";